export default "__VITE_ASSET__CJGbNIKQ__"